export const writeToClipboard = (text: string) =>
  navigator.clipboard.writeText(text)

export const copyToClipboard = (text: string) => () => writeToClipboard(text)
